export const getAuthToken = (): string | null => {
  const match = document.cookie.match(/(^| )token_access=([^;]+)/);
  return match ? decodeURIComponent(match[2]) : null;
};

export const setAuthToken = (access: string, refresh: string, days = 5) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `token_access=${encodeURIComponent(access)}; expires=${expires}; path=/`;
  document.cookie = `token_refresh=${encodeURIComponent(refresh)}; expires=${expires}; path=/`;
};

export const clearAuthToken = () => {
  document.cookie = "token_access=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  document.cookie = "token_refresh=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
};

export const getTermsAccepted = (): boolean => {
  return document.cookie.match(/(^| )ai2peat_terms_accepted=true/) !== null;
};

export const setTermsAccepted = () => {
  const expires = new Date(Date.now() + 365 * 864e5).toUTCString();
  document.cookie = `ai2peat_terms_accepted=true; expires=${expires}; path=/; SameSite=Lax`;
};